import React, { useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import Bread from "../../common/Bread";
import StandardTarrif from "../../components/StandardTarrif/StandardTarrif";

function Staticpages() {
  const [title, setTitle] = useState("");
  const { slug } = useParams();
  function titleSwitch() {
    switch (slug) {
      case "standard-tariff-charges":
        {
          setTitle("Standard Tariff Charges");
        }

        break;
      default:
        {
          setTitle("Page not Found");
        }
        break;
    }
  }

  var breadMemo = useMemo(titleSwitch, [slug]);

  const breadcrumList = {
    image: "",
    title: title,
    l1: "Home",
    l2: "Standard Tariff Charges",
    l3: "",
  };
  return (
    <Bread data={breadcrumList}>
      <div>
        {slug === "standard-tariff-charges" ? (
          <StandardTarrif />
        ) : (
          <h1>Not Found</h1>
        )}
      </div>
    </Bread>
  );
}

export default Staticpages;
